<template>
  <div class="lottery-result-page">
    <!-- ============ 筛选区（与系统其他页面 list-filter-panel 一致） ============ -->
    <div class="list-filter-panel">
      <div class="list-filter-row list-filter-fields-row">
        <!-- school-role 只能看本分社（已固定带 branchId），不再提供分社筛选 -->
        <div class="filter-field-item" v-if="!isSchoolRole">
          <span class="filter-field-label">分社</span>
          <a-select
            :filterOption="filterOption"
            showSearch
            v-model="branchName"
            allowClear
            placeholder="全部"
            style="width: 160px"
          >
            <a-select-option value>全部</a-select-option>
            <a-select-option
              v-for="(item, index) in branchList"
              :key="index"
              :value="item"
              >{{ item }}</a-select-option
            >
          </a-select>
        </div>
        <div class="filter-field-item">
          <span class="filter-field-label">组别</span>
          <a-select v-model="viewLevel" placeholder="全部" style="width: 120px">
            <a-select-option value="all">全部</a-select-option>
            <a-select-option value="1">中职</a-select-option>
            <a-select-option value="2">高职</a-select-option>
          </a-select>
        </div>
      </div>
      <div class="list-filter-row list-filter-footer">
        <a-button @click="resetFilter">重置筛选</a-button>
        <a-button type="primary" @click="loadData">查询</a-button>
        <span class="list-filter-footer-split"></span>
        <a-button
          type="primary"
          icon="download"
          :loading="exporting"
          @click="handleExport"
          >导出抽签结果</a-button
        >
        <span class="list-filter-count">
          共 <b>{{ records.length }}</b> 条记录
        </span>
      </div>
    </div>

    <!-- ============ 公示总览舞台 ============ -->
    <!-- <div class="stage">
      <div class="stage-bg">
        <span class="aurora aurora-1"></span>
        <span class="aurora aurora-2"></span>
        <span class="aurora aurora-3"></span>
        <span class="grid"></span>
        <span class="spot"></span>
      </div>
      <div class="overview">
        <div class="ov-icon">🏆</div>
        <div class="ov-title">初赛抽签结果公示</div>
        <div class="ov-sub">
          {{ drawRound ? drawRound + " 届 · " : "" }}本次抽签已完成，以下为各学校抽中题目
        </div>
        <div class="ov-cards">
          <div class="ov-card">
            <div class="ov-num">{{ records.length }}</div>
            <div class="ov-label">参抽学校（所）</div>
          </div>
          <div class="ov-card">
            <div class="ov-num">{{ stat["中职"] || 0 }}</div>
            <div class="ov-label">中职（所）</div>
          </div>
          <div class="ov-card">
            <div class="ov-num">{{ stat["高职"] || 0 }}</div>
            <div class="ov-label">高职（所）</div>
          </div>
        </div>
      </div>
    </div> -->

    <!-- ============ 结果表格 ============ -->
    <div class="record-section">
      <div class="section-title">
        {{ viewLevel === "all" ? "全部抽签结果" : levelName + "组抽签结果" }}
        <!-- <span class="section-count">按分社及抽签序号排列</span> -->
      </div>
      <a-table
        class="result-table"
        style="text-align: center"
        :columns="columns"
        :data-source="filteredList"
        :loading="loading"
        rowKey="_rowKey"
        :bordered="true"
        :pagination="tablePage"
        :locale="{ emptyText: loading ? '加载中…' : '暂无抽签结果，请先完成抽签' }"
      >
        <template slot="index" slot-scope="text, record, index">
          <span>{{ index + 1 }}</span>
        </template>
        <template slot="branchName" slot-scope="text">
          <span>{{ text || "未分配分社" }}</span>
        </template>
        <template slot="level" slot-scope="text, record">
          <span>{{ levelText(record) || "未分组" }}</span>
        </template>
      </a-table>
    </div>
  </div>
</template>

<script>
import {
  lxDrawResultStatList,
  lxDrawResultStatListByBranch,
  lxDrawResultExportXls,
  lxDrawResultExportByBranch,
  lxDrawResultBranchNames,
} from "@/api/index";

// 章节库/统计接口返回可能是数组，也可能是 { records: [...] }（jeecg 分页结构）
function pickRecords(res) {
  const r = res && res.result;
  if (Array.isArray(r)) return r;
  if (r && Array.isArray(r.records)) return r.records;
  return [];
}

// jeecg 统一返回：成功码 200；失败时 success=false 并带 message
function isOk(res) {
  if (!res) return false;
  if (res.success === false) return false;
  if (res.code !== undefined && res.code !== 200 && res.code !== 0) return false;
  return true;
}

export default {
  name: "LotteryResult",
  data() {
    return {
      loading: false,
      exporting: false, // Excel 导出中
      viewLevel: "all", // all | 1(中职) | 2(高职)，查询时带 levelType 请求接口
      branchName: "", // 分社名称，查询/导出传 branchName
      branchList: [], // 分社下拉（lx/lxDrawResult/branchNames）
      drawRound: "", // 届别/批次，默认查全部
      records: [], // 全部抽签结果（跨分社、跨组别）
      // 表格列定义（与系统其他表格一致：全部居中）
      columns: [
        {
          title: "序号",
          dataIndex: "index",
          key: "index",
          width: 70,
          align: "center",
          scopedSlots: { customRender: "index" },
        },
        {
          title: "分社",
          dataIndex: "branchName",
          key: "branchName",
          width: 180,
          align: "center",
          scopedSlots: { customRender: "branchName" },
        },
        {
          title: "学校",
          dataIndex: "schoolName",
          key: "schoolName",
          align: "center",
          scopedSlots: { customRender: "schoolName" },
        },
        {
          title: "组别",
          dataIndex: "levelType",
          key: "level",
          width: 100,
          align: "center",
          scopedSlots: { customRender: "level" },
        },
        {
          title: "抽中题目",
          dataIndex: "drawName",
          key: "drawName",
          align: "center",
          scopedSlots: { customRender: "drawName" },
        },
      ],
      // 表格分页：每页 20 条，展示总数
      tablePage: {
        pageSize: 20,
        showSizeChanger: false,
        showTotal: (t) => `共 ${t} 所学校`,
      },
    };
  },
  computed: {
    // 当前登录角色
    role() {
      return this.$store.state.role || "";
    },
    // 分社角色：查询/导出需额外带 branchId（登录人 id），只看本分社数据
    isSchoolRole() {
      return this.role === "school-role";
    },
    // 当前组别展示名
    levelName() {
      return this.viewLevel === "2" ? "高职" : this.viewLevel === "1" ? "中职" : "全部";
    },
    // 按组别统计学校数
    stat() {
      const s = { 中职: 0, 高职: 0 };
      this.records.forEach((r) => {
        const t = this.levelText(r);
        if (s[t] !== undefined) s[t] += 1;
      });
      return s;
    },
    // 组别过滤由接口 levelType 参数完成，前端只做排序
    filteredList() {
      return this.records.slice().sort((a, b) => {
        const ab = (a.branchName || "").localeCompare(
          b.branchName || "",
          "zh"
        );
        if (ab !== 0) return ab;
        return (a.drawNo || 0) - (b.drawNo || 0);
      });
    },
  },
  created() {
    // school-role 已隐藏分社筛选（接口按 branchId 限定本分社），无需加载分社下拉
    if (!this.isSchoolRole) this.getBranchList();
    this.loadData();
  },
  methods: {
    // 组别展示名：优先字典文本，兼容字典值 1=中职 / 2=高职
    levelText(r) {
      const t = r.levelTypeDictText || r.levelType;
      if (t === "1") return "中职";
      if (t === "2") return "高职";
      return t || "";
    },
    // 分社下拉：走 lx/lxDrawResult/branchNames
    // 返回兼容：字符串数组 / 分页 { records:[...] } / 对象数组（branchName | name），统一压成名称数组
    async getBranchList() {
      try {
        const res = await lxDrawResultBranchNames();
        if (!isOk(res)) return;
        const list = pickRecords(res);
        this.branchList = list
          .map((item) => {
            if (typeof item === "string") return item;
            return item.branchName || item.name || "";
          })
          .filter((v) => !!v);
      } catch (e) {
        console.error("分社列表加载失败", e);
      }
    },
    // 下拉搜索（与系统其他页面同款模糊匹配）
    filterOption(input, option) {
      return (
        option.componentOptions.children[0].text
          .toLowerCase()
          .indexOf(input.toLowerCase()) >= 0
      );
    },
    // 重置筛选：分社、组别回到默认后重新查询
    resetFilter() {
      this.branchName = "";
      this.viewLevel = "all";
      this.loadData();
    },
    // 当前筛选条件（查询与导出共用）
    buildParams() {
      const params = {};
      if (this.drawRound) params.drawRound = this.drawRound;
      if (this.viewLevel && this.viewLevel !== "all")
        params.levelType = this.viewLevel;
      if (this.branchName) params.branchName = this.branchName;
      // school-role（分社）：只看本分社数据，接口额外带登录人 id 作为 branchId
      if (this.isSchoolRole) {
        const u = this.$store.state.user || {};
        if (u.id) params.branchId = u.id;
      }
      return params;
    },
    // 加载抽签结果统计
    // education-role：statList（全量，可按分社/组别筛选）
    // school-role  ：statListByBranch + branchId=登录人 id（只看本分社）
    async loadData() {
      this.loading = true;
      try {
        const params = { pageNo: 1, pageSize: 1000, ...this.buildParams() };
        const res = await (this.isSchoolRole
          ? lxDrawResultStatListByBranch(params)
          : lxDrawResultStatList(params));
        if (isOk(res)) {
          this.records = (pickRecords(res) || []).map((r, i) => ({
            ...r,
            _rowKey: (r.id || "") + "-" + i,
          }));
          if (!this.records.length) {
            // this.$message.info("暂无抽签结果");
          }
        } else {
          this.$message.error((res && res.message) || "结果加载失败");
        }
      } catch (e) {
        console.error(e);
        this.$message.error("结果加载失败，请稍后重试");
      } finally {
        this.loading = false;
      }
    },
    // 导出抽签结果 Excel（接口返回二进制流）
    // 与查询同理按角色分流：education-role 走 exportStatList，
    // school-role 走 exportStatListByBranch + branchId=登录人 id
    async handleExport() {
      if (this.exporting) return;
      this.exporting = true;
      try {
        const params = { ...this.buildParams() };
        const res = await (this.isSchoolRole
          ? lxDrawResultExportByBranch(params)
          : lxDrawResultExportXls(params));
        if (!res) {
          this.$message.warning("文件下载失败");
          return;
        }
        // 后端异常时可能返回 JSON 而非 Excel 流，提前识别避免下载损坏文件
        if (res.type === "application/json") {
          const text = await new Response(res).text();
          let msg = "导出失败";
          try {
            msg = (JSON.parse(text) || {}).message || msg;
          } catch (e) {
            /* 忽略解析失败 */
          }
          this.$message.error(msg);
          return;
        }
        const suffix = this.viewLevel === "all" ? "" : this.levelName + "组";
        const fileName = "抽签结果公示" + suffix + ".xls";
        if (typeof window.navigator.msSaveBlob !== "undefined") {
          window.navigator.msSaveBlob(
            new Blob([res], { type: "application/vnd.ms-excel" }),
            fileName
          );
        } else {
          const url = window.URL.createObjectURL(
            new Blob([res], { type: "application/vnd.ms-excel" })
          );
          const link = document.createElement("a");
          link.style.display = "none";
          link.href = url;
          link.setAttribute("download", fileName);
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          window.URL.revokeObjectURL(url);
        }
      } catch (e) {
        console.error(e);
        this.$message.error("导出失败，请稍后重试");
      } finally {
        this.exporting = false;
      }
    },
  },
};
</script>

<style scoped lang="scss">
.lottery-result-page {
  padding: 20px 24px 30px;
  color: #1f1f1f;
}

/* ---------- 筛选区：与系统其他页面（报名管理 / 申报管理）保持一致 ---------- */
.list-filter-panel {
  margin-bottom: 14px;
  padding: 14px 16px;
  background: #f8faff;
  border: 1px solid #d6e4ff;
  border-radius: 10px;
}
.list-filter-row {
  margin-bottom: 12px;
  &:last-child {
    margin-bottom: 0;
  }
}
.list-filter-fields-row {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 16px 24px;
}
.filter-field-item {
  display: flex;
  align-items: center;
  gap: 8px;
}
.filter-field-label {
  flex-shrink: 0;
  font-size: 14px;
  font-weight: 600;
  color: #333;
}
.list-filter-footer {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 10px;
  padding-top: 14px;
  border-top: 1px dashed #e0e0e0;
}
.list-filter-footer-split {
  width: 1px;
  height: 18px;
  margin: 0 4px;
  background: #d9d9d9;
  flex-shrink: 0;
}
.list-filter-count {
  margin-left: auto;
  font-size: 13px;
  color: #666;
  b {
    color: #9a0b00;
    font-weight: 600;
  }
}

/* ---------- 表格卡片 ---------- */
.record-section {
  margin-top: 22px;
  background: #fff;
  border: 1px solid #eaf0ff;
  border-radius: 10px;
  padding: 16px 18px;
  box-shadow: 0 2px 10px rgba(0, 90, 245, 0.05);
}
.section-title {
  display: inline-block;
  padding: 4px 12px;
  margin-bottom: 14px;
  font-size: 16px;
  font-weight: 600;
  color: #9a0b00;
  //background: #eef4ff;
  border-radius: 999px;
}
.section-count {
  margin-left: 10px;
  font-size: 12px;
  font-weight: 400;
  color: #a0a0a0;
}

/* ---------- 公示总览舞台 ---------- */
.stage {
  position: relative;
  height: 300px;
  border-radius: 16px;
  overflow: hidden;
  margin-bottom: 18px;
  background: radial-gradient(
      1100px 640px at 50% -18%,
      #ffffff 0%,
      #fff7ee 36%,
      #ffeddf 66%,
      #fde2cf 100%
    ),
    #fff7ee;
  border: 1px solid #ffe1c9;
  box-shadow: 0 18px 46px rgba(154, 11, 0, 0.14);
}
.stage-bg {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  overflow: hidden;
}
.aurora {
  position: absolute;
  border-radius: 50%;
  filter: blur(78px);
  opacity: 0.4;
  animation: float 16s ease-in-out infinite;
}
.aurora-1 {
  width: 430px;
  height: 430px;
  left: -90px;
  top: -130px;
  background: #ff9d5c;
}
.aurora-2 {
  width: 470px;
  height: 470px;
  right: -110px;
  top: -70px;
  background: #ff6b8a;
  opacity: 0.26;
  animation-delay: -5s;
}
.aurora-3 {
  width: 400px;
  height: 400px;
  left: 40%;
  bottom: -230px;
  background: #ffc94d;
  opacity: 0.42;
  animation-delay: -9s;
}
@keyframes float {
  0%,
  100% {
    transform: translate3d(0, 0, 0) scale(1);
  }
  33% {
    transform: translate3d(40px, 30px, 0) scale(1.12);
  }
  66% {
    transform: translate3d(-30px, -20px, 0) scale(0.94);
  }
}
.grid {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background-image: linear-gradient(
      rgba(154, 11, 0, 0.055) 1px,
      transparent 1px
    ),
    linear-gradient(90deg, rgba(154, 11, 0, 0.055) 1px, transparent 1px);
  background-size: 42px 42px;
  mask-image: radial-gradient(circle at 50% 45%, #000 30%, transparent 78%);
  -webkit-mask-image: radial-gradient(circle at 50% 45%, #000 30%, transparent 78%);
}
.spot {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: radial-gradient(
    circle at 50% 40%,
    rgba(255, 255, 255, 0.92),
    transparent 58%
  );
}
.overview {
  position: relative;
  z-index: 2;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
}
.ov-icon {
  font-size: 48px;
  line-height: 1;
  animation: ovPop 0.7s cubic-bezier(0.2, 1.5, 0.4, 1) both;
}
@keyframes ovPop {
  0% {
    transform: scale(0.2) rotate(-25deg);
    opacity: 0;
  }
  100% {
    transform: scale(1) rotate(0);
    opacity: 1;
  }
}
.ov-title {
  margin-top: 10px;
  font-size: 24px;
  font-weight: 800;
  letter-spacing: 3px;
  background: linear-gradient(90deg, #9a0b00, #e02020 48%, #b8860b);
  -webkit-background-clip: text;
  background-clip: text;
  color: transparent;
}
.ov-sub {
  margin-top: 6px;
  font-size: 13px;
  color: rgba(107, 58, 31, 0.62);
}
.ov-cards {
  display: flex;
  gap: 16px;
  margin-top: 18px;
}
.ov-card {
  min-width: 120px;
  padding: 10px 18px 12px;
  border-radius: 12px;
  background: rgba(255, 255, 255, 0.78);
  border: 1px solid rgba(224, 32, 32, 0.16);
  box-shadow: 0 10px 26px rgba(154, 11, 0, 0.1);
  animation: ovCardIn 0.6s cubic-bezier(0.16, 1.02, 0.3, 1) both;
  &:nth-child(2) {
    animation-delay: 0.08s;
  }
  &:nth-child(3) {
    animation-delay: 0.16s;
  }
}
@keyframes ovCardIn {
  0% {
    opacity: 0;
    transform: translateY(18px) scale(0.92);
  }
  100% {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
}
.ov-num {
  font-size: 30px;
  font-weight: 800;
  line-height: 1.15;
  color: #9a0b00;
  font-family: "DIN Alternate", "Microsoft YaHei", sans-serif;
}
.ov-label {
  margin-top: 4px;
  font-size: 12px;
  color: #8c7a6a;
}

/* ---------- 结果表格：与其他表格（reviewSetUp/userTableView）一致 ----------
   仅保留与其他表格相同的三处覆盖：表头/内容 18px、列标题色 #73593b，其余全部 antd 默认 */
.result-table {
  /deep/ .ant-table-thead > tr > th {
    font-size: 16px !important;
    color:#000;
  }
  /deep/ .ant-table-tbody > tr > td {
    font-size: 14px;
  }
  // /deep/ .ant-table-column-title {
  //   color: #73593b;
  // }
}
</style>
